import React , {useEffect, useState}from 'react';
import {Link, NavLink} from "react-router-dom";

import {useMenuList} from '../../../queries/menu';
import "./index.scss"
import InfinitProgressBar from '../../../components/InfiniteProgressBar';
import { Button} from 'react-bootstrap';


function MegaMenu(props) {
   
    
    const {error, loading, data} = useMenuList();
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>
    
    return (
        data.menu[0].menuItemsList.contentItems.map(item=>(  
           
            <li key={item.id} className="ruby-menu-mega" style={{float:"right"}}>
                {
                    item.megaMenu || item.subMenu ? <span style={{color:"black", direction:"ltr", cursor: "pointer" }}>{item.displayText}</span> :
                    item.fastAccess ? <Button onClick={() => {props.openDialog.setOpen(true)}} style={{color:"white", direction:"ltr", borderColor: 'transparent',    display: 'block',
                    lineHeight: '37px', borderRadius: '5px', borderBottomRightRadius: '0px', borderBottomLeftRadius: '0px', backgroundColor: 'red' }} >{item.displayText}
                    </Button>  : <Link style={{color:"black", direction:"ltr" }} to={`${process.env.PUBLIC_URL + item.linkMenuItem.url}${item.pageParam ? '/' + item.pageParam : ''}`}>{item.displayText}
                </Link>}
                {
               
                item.megaMenu?
                <div className="ruby-grid ruby-grid-lined">
                    <div className="ruby-row">
                    {
                        item.bag.contentItems.map((subItem,index)=>{
                            return (
                                
                                <div className="ruby-col-2" style={{width: `${(parseInt(subItem.bag.contentItems.length/5) + 1) * 20 }%`}}>
                                    <h3 className="ruby-list-heading">{subItem.displayText}</h3>
                                    <ul style={{columns: `${parseInt(subItem.bag.contentItems.length/5) + 1}`}}>
                                    {
                                        
                                        subItem.bag.contentItems.map((innerItem,innerIndex)=>{
                                            return <li key={innerIndex}><Link to={`${'/about'+ innerItem.linkMenuItem.url}`}>{innerItem.displayText}</Link></li>
                                        })
                                    }
                                    </ul>
                                </div>
                            )
                        })
                        
                    }
                </div>
                </div>
            
        :
        item.subMenu?
        // <div style={{backgroundColor: 'red'}}>
        <ul  >
        {
           
            item.bag.contentItems.map((megaItem, indx)=>( megaItem.isExternalUrl ? 
                <li key={indx}><a href={`${megaItem.linkMenuItem.url}`} target="_blank" 
                rel="noopener noreferrer">{megaItem.displayText}</a>
                   
                {
                    megaItem.bag.contentItems.map((subItem,index)=>{
                        return (
                            <ul >
                                {
                                    subItem.bag.contentItems.map((listItem,idx)=>{
                                        return subItem.isExternalUrl ? <li key={idx}><a href={subItem.linkMenuItem.url}>{listItem.displayText}</a></li> :
                                         <li key={idx}><Link to={`${'/services'+ subItem.linkMenuItem.url}`}>{listItem.displayText}</Link></li>
                                    })
                                }
                            </ul>
                        )
                    })
                    
                }
            {/* </ul> */}
        </li>  
                :
                <li key={indx}><Link to={`${ megaItem.linkMenuItem.url}`}>{megaItem.displayText}</Link>
                   
                        {
                            megaItem.bag.contentItems.map((subItem,index)=>{
                                return (
                                    <ul >
                                        {
                                            subItem.bag.contentItems.map((listItem,idx)=>{
                                                return subItem.isExternalUrl ? <li key={idx}><a href={subItem.linkMenuItem.url}>{listItem.displayText}</a></li> :
                                                 <li key={idx}><Link to={`${'/services'+ subItem.linkMenuItem.url}`}>{listItem.displayText}</Link></li>
                                            })
                                        }
                                    </ul>
                                )
                            })
                            
                        }
                    {/* </ul> */}
                </li>
            ))
        }
    </ul>
    // </div>

        :
        null
                }
        </li>
        )
        
        )
    );
}

export default MegaMenu;



